import React from 'react';
import './style.scss';
import Button from '../../controls/button';
import clsx from 'clsx';

interface Props {
  className?: string;
  wording?: string;
}

const PageError = ({
  className,
  wording = 'We have a super-duper unpredictable error.'
}: Props) => (
  <div className={clsx('page-error', className)}>
    <h1 className='mb-20'>Oopsie Woopsie</h1>
    <h5>{wording} Wanna refresh?</h5>
    <Button onClick={() => window.location.reload()}>Alright, let's try</Button>
  </div>
);

export default PageError;
